import React, { Component } from "react";
import { hideLoading, LoadableDataState, showErrorMessage, showLoading } from "@my-dld/utils/UIUtils";
import { SpinnerLoader } from "@my-dld/components/SpinnerLoader";
import { EjariContractContext, updateContractContext } from "@eres/ejari-core/contexts/EjariContractContext";
import { Tenant } from "@eres/ejari-api/Entity/tenant";
import _ from "lodash";
import PersonTenant from "./TenantForms/PersonTenant";
import CompanyTenant from "./TenantForms/CompanyTenant";
import Strings from "@my-dld/assets/strings";
import FormRow from "@my-dld/components/Form/FormRow";
import FormAction from "@my-dld/components/Form/FormAction";
import { RoutedViewProps } from "@my-dld/utils/UrlUtils";
import { TenantForm } from "./TenantForms";
import { EjariApi } from "@eres/ejari-api";
import { navigateWithSibling } from "@my-dld/utils/StoreUtils";
import { TenancyContactAction } from "@eres/ejari-core/constants";

interface Props extends RoutedViewProps {

}

interface State extends LoadableDataState {
	isCompany: boolean;
	tenant?: Tenant;
	TotalCoTenants?: number;
	isValid: boolean;
}

class TenantInfo extends Component<Props, State> {
	static contextType = EjariContractContext;
	context!: React.ContextType<typeof EjariContractContext>;

	form: TenantForm | null = null;

	constructor( props: Props ) {
		super( props );
		this.state = {
			loadState: `loading`,
			errorContainer: {},
			isCompany: false,
			isValid: false,
		};
	}

	componentDidMount() {
		const { OrgTenant, tenant } = this.context;
		const data: Tenant = {};
		_.merge( data, OrgTenant, tenant, this.context.contract?.TotalCoTenants );
		const isCompany = data.IsCompany === true;
		this.setState( { loadState: "done", tenant: data, isCompany: isCompany, TotalCoTenants: this.context.contract?.TotalCoTenants } );
	}

	setFormRef = ( e: TenantForm | null ) => {
		this.form = e;
		this.updateValidity();
	};
	updateValidity = () => {
		this.setState( {
			isValid: this.isValid(),
		} );
	};

	render() {
		const { loadState } = this.state;
		if ( loadState === "loading" )
			return <SpinnerLoader/>;
		const { tenant, isCompany, isValid } = this.state;
		const Form = isCompany ? <>
			<CompanyTenant
				onDataChanged={ this.updateValidity }
				ref={ this.setFormRef }/>
		</> : <PersonTenant
			onDataChanged={ this.updateValidity }
			ref={ this.setFormRef }/>;
		return <>
			{ Form }
			<FormRow>
				<FormAction
					disablePrimaryAction={ !isValid }
					groupClassName={ "text-center" }
					primaryActionLabel={ Strings.continue }
					onPrimaryAction={ this.onContinue }
					secondaryActionLabel={ Strings.back }
					onSecondaryAction={ this.onBack }
				/>
			</FormRow>
		</>;

	}

	onBack = () => {
		if ( this.context.action == TenancyContactAction.RENEW_CONTRACT ) {
			this.props.history.go( -2 );
		} else
			this.props.history.goBack();
	};
	onContinue = () => {
		let { tenant } = this.state;
		if ( this.form && tenant ) {
			tenant = this.form.updateTenant( tenant! );
			const TotalCoTenants = this.form.updateTotalCoTenants?.();

			console.log( TotalCoTenants );
			tenant = _.omit( tenant, [ "TotalCoTenants" ] );
			showLoading();
			EjariApi.validateTenant( tenant, this.context.activeUserId! )
			.then( x => {
				hideLoading();
				updateContractContext( { tenant: tenant, TotalCoTenants: TotalCoTenants } );
				navigateWithSibling( "tenant", "contract" );
			} ).catch( e => {
				hideLoading();
				showErrorMessage( e );
			} );
		}
	};
	isValid = () => {
		let isValid = true;
		isValid = isValid && this.form != null && this.form.validate();
		return isValid;
	};
}

export default TenantInfo;
